<template>
    <RouterView />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'

import { mapLocaleToHrefLang } from '@/i18n/helpers'
import { useI18nAddon } from '@/i18n/i18n'

const { currentLocale } = useI18nAddon()

useHead({
    htmlAttrs: {
        class: 'strict-px',
        lang: mapLocaleToHrefLang(currentLocale.value),
        translate: 'no',
    },
})
</script>

<style critical>
@import '@/assets/styles/index.css';

html {
    touch-action: manipulation;
    -webkit-font-smoothing: antialiased;
}

html.strict-px {
    font-size: 1px;
}

@media (width >= 1800px) {
    html.strict-px {
        font-size: calc(100vw / 1800);
    }
}

body {
    min-height: 100%;
    background-color: var(--black);
    color: var(--white);
    font-family: var(--font-family);
    scrollbar-gutter: stable;
    overflow-x: clip;
}
</style>
